var Interfaces = {
    'openApp': 'openApp',
    'processDownload': 'processDownload',
    'supportMethod': 'supportMethod',
    'share': 'share',
    'goPage': 'goPage',
    'installApp': 'installApp',
    'sendCoins': 'sendCoins',
    'sendMsg': 'sendMsg',
    'processVideo': 'processVideo',
    'videoMerge': 'videoMerge',
    'socialDownload': 'socialDownload',
    'eventReport': 'eventReport',
    'processException': 'processException',
    // 2020.10.12
    'searchResult': 'searchResult'
};

var JsBridgeHandlers = (function(){
    var _config = {
        "supportMethod": null
    };

    // 注册事件, 供 native 调用 
	function registHandler() {
		var bridge = window.WebViewJavascriptBridge || null;
		// console.log('regist nextPage 111', bridge);
		if(bridge) {
			// console.log('regist nextPage 222');
			bridge.registerHandler("nextPage",function(data, responseCallback) {
				if(!!searcher){
                    searcher.nextPage();
                }
			});
		}
	}
	registHandler();

    var _priFn = {
        checkJsApi: function(name){
            if(Interfaces[name]){
                return true;
            }else{
                return false;
            }
        }
    };

    var pubFn = {
        sendMsg: function(opts, cb){
            var options = opts || {};
            var cbFn = cb || function() {
                // console.log('send msg = ', res);
            }

            if(!_priFn.checkJsApi('sendMsg')){
                return;
            }

            WebViewJavascriptBridge.callHandler(Interfaces['sendMsg'], options, cbFn);
        },
        getSupportMethod: function(opts, callback){
            var options = opts || {};

            _config['supportMethod'] = Interfaces;
            WebViewJavascriptBridge.callHandler(Interfaces['supportMethod'], options, function(res){
                var methodNames = null;
                // console.log('support methods = ', res);
                if(res === 'Success' || res === 'DefaultHandler response data'){
                    // console.log('未支持任何方法');
                    callback(false);
                }else{
                    methodNames = typeof res === 'string' ? window.JSON.parse(res)['methodName'] : res['methodName'];

                    for(var item in Interfaces){
                        _config['supportMethod'][item] = '';
                    }

                    for(var i = 0; i < methodNames.length; i++){
                        _config['supportMethod'][methodNames[i]] = methodNames[i];
                    }

                    callback(_config);
                }
            });
        },

        eventReport: function(evt){
            if(!_priFn.checkJsApi('eventReport')){
				return;
			}

			try{
				WebViewJavascriptBridge.callHandler(
					'eventReport'
					, evt
					, function (responseData) {

					}
				);
			}catch(e){
				// console.log('eventReport = ', evt);
			}
        },

        processException: function(exceptionInfo){
            if(!_priFn.checkJsApi('processException')){
                return;
            }

            try{
                WebViewJavascriptBridge.callHandler(
                    'processException'
                    , {'param': exceptionInfo}
                    , function(responseData) {
    
                    }
                );
            }catch(e){
				// console.log('processException = ', exceptionInfo);
			}
        },

        socialDownload: function(fileArr){
            if(!_priFn.checkJsApi('socialDownload')){
                return;
            }

            WebViewJavascriptBridge.callHandler(
                'socialDownload'
                , {'param': fileArr}
                , function(responseData) {

                }
            );
        },

        videoMerge: function(fileArr){
            if(!_priFn.checkJsApi('videoMerge')){
                return;
            }

            WebViewJavascriptBridge.callHandler(
                'videoMerge'
                , {'param': fileArr}
                , function(responseData) {

                }
            );
        },

        searchResult: function(result){
			if(!_priFn.checkJsApi('searchResult')){
				return;
			}

			try{
				WebViewJavascriptBridge.callHandler(
					'searchResult'
					, { 'param': result }
					, function (responseData) {

					}
				);
			}catch(e){
				// console.log('searchResult = ', result);
			}
		}
    };

    var __JSBH__ = function(){
        // console.log('bridge handler init.');
    };
    __JSBH__.prototype = pubFn;

    return __JSBH__;
})(window);

export default new JsBridgeHandlers();